<script>
export default {
    props: {
        onDismiss: Function,
        onConfirm: Function
    },
    methods: {

    }
}
</script>
<template>
    <div class="row mt-4">
        <p>{{ $translate('checkout.domain_id_protect_confirm_text_1') }}</p>
        <p>{{ $translate('checkout.domain_id_protect_confirm_text_2') }}</p>
        <div class="col-6">
            <button class="btn btn-circle w-100" @click="onConfirm()">{{ $translate('checkout.domain_id_protect_confirm_text_confirm') }}</button>
        </div>
        <div class="col-6">
            <button class="btn btn-circle btn-primary w-100" @click="onDismiss()">{{ $translate('checkout.domain_id_protect_confirm_text_dismiss') }}</button>
        </div>
    </div>
</template>
